import { useRequest } from 'hooks/useRequest'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import {useState} from 'react'
import LoaderTwo from 'pages/LoaderTwo'
import { dataLayerPush } from 'utils/Datalayer'
import auth from 'utils/Auth'
import useTranslate from 'hooks/useTranslate'


const ExternalAuth = () => {
    const [request,loading] = useRequest()
    const [firstRender, setFirstRender] = useState(true)
    const {t} = useTranslate()

    const navigate = useNavigate();


    useEffect(() => {
        setFirstRender(false)
        if (firstRender) {
            const query = new URLSearchParams(window.location.search);
            request('/ExternalAuth/Google', {
                method: 'POST',
                params: {
                    code: query.get('code'),
                    state: query.get('state'),
                },
            }).then((res) => {
                if (res.data) {
                    localStorage.setItem('auth', JSON.stringify(res?.data?.result))

                    const userInfo = auth.getUserInfoFromToken()
                   
                    dataLayerPush({
                      event:"login",
                      user_email:userInfo?.email,
                      login_type:t('signUpWith',{with:'Google'}),
                      user_id: userInfo?.nameid
                    })
                    navigate("/uye-girisi");
                } else if (res.response.status == 500){
                   navigate('/hata/500')
                }
            })
        }
    }, [])
    if (loading) {
        return <div className="skeleton-home-slider">
        <div className="skeleton"/>
        <LoaderTwo isDataLoading={loading} />
    </div>
    }
}

export default ExternalAuth